import React from 'react';
import ReactDOM from 'react-dom';
import ContentTabs from "../../../ContentTabs/components/ContentTabs";

const data = [
    {
        backgroundUrl: "/images/solutions/education/Teaching staff_770.jpg",
        iconUrl: "/images/solutions/education/education.svg",
        title: i18njs["Solutions.TeachingStaff"],
        mainText: i18njs["Solutions.TeachingStaffMainText"],
        mainText2: i18njs["Solutions.TeachingStaffMainText2"],
        tabIconUrl: "/images/solutions/education/education.svg"
    },
    {
        backgroundUrl: "/images/solutions/IT_770.jpg",
        iconUrl: "/images/solutions/IT.svg",
        title: i18njs["Solutions.ItDept"],
        mainText: i18njs["Solutions.ItDeptMainTextEducation"],
        mainText2: i18njs["Solutions.ItDeptMainText2Education"],
        tabIconUrl: "/images/solutions/IT.svg"
    }
]

ReactDOM.render(
    <ContentTabs data={data}></ContentTabs>,
    document.getElementById("educationOms")
);
